import { Injectable } from '@angular/core';
import { VideoSDKMeeting } from '@videosdk.live/rtc-js-prebuilt';
import { environment } from '../../../environments/environment';
import { SharedService } from '../../shared/shared.service';
import { SheetProps } from 'xlsx';

@Injectable()
export class VideoCallService {

  public apiKey: string = '';
  public apiToken: string = '';
  public meeting: any  = null;

  
  


  constructor(private sharedService: SharedService) {
    // Constructor del servicio
    this.apiKey = environment.VIDEOSDK_API_KEY;
    this.apiToken = environment.VIDEOSDK_API_TOKEN;

    
  }

  
  async createVideoCall(name_user: string,meeting_id:string,recording:boolean)
  {
  
    try {

      const meetingId = meeting_id;
      const name = name_user;
      const url = 'https://videocall.smartdataautomation.com/?meetingId=' + meetingId;
      const config = {
      name: name,
      meetingId: meetingId,
      apiKey: this.apiKey,
      token:this.apiToken,

      type: "image", // "blur"
      imageUrl: "https://www.kdeblog.com/wp-content/uploads/2012/12/KDE-4.10-Wallpapaper-600x400.png",
    
      region: "sg001", // region for new meeting

      containerId: "videoCall",
      redirectOnLeave: "",

      micEnabled: true,
      webcamEnabled: true,
      participantCanToggleSelfWebcam: true,
      participantCanToggleSelfMic: true,
      participantCanLeave: false, // if false, leave button won't be visible

      chatEnabled: false,
      screenShareEnabled: true,
      pollEnabled: false,
      whiteboardEnabled: true,
      raiseHandEnabled: true,

      theme: "DARK", // DARK || LIGHT || DEFAULT

      recording: {
        autoStart: recording, 
        enabled: false,
        webhookUrl: "https://www.videosdk.live/callback",
        awsDirPath: `/meeting-recordings/${meetingId}/`, 
      },

      livestream: {
        autoStart: false,
        enabled: false,
      },

      layout: {
        type: "SPOTLIGHT", // "SPOTLIGHT" | "SIDEBAR" | "GRID"
        priority: "PIN", // "SPEAKER" | "PIN",
        // gridSize: 3,
      },

      branding: {
        enabled: false,
        logoURL:
          "https://static.zujonow.com/videosdk.live/videosdk_logo_circle_big.png",
        name: "Multiagente",
        poweredBy: false,
      },

      permissions: {
        pin: true,
        askToJoin: false, // Ask joined participants for entry in meeting
        toggleParticipantMic: true, // Can toggle other participant's mic
        toggleParticipantWebcam: true, // Can toggle other participant's webcam
        drawOnWhiteboard: false, // Can draw on whiteboard
        toggleWhiteboard: false, // Can toggle whiteboard
        toggleRecording: false, // Can toggle meeting recording
        toggleLivestream: false, //can toggle live stream
        removeParticipant: false, // Can remove participant
        endMeeting: true, // Can end meeting
        changeLayout: true, //can change layout
        //  ...other permissions
        toggleParticipantMode: true,
        toggleHls: false,
        toggleVirtualBackground: true,
      },

      joinScreen: {
        visible: false, // Show the join screen ?
        title: "Sala#", // Meeting title
        meetingUrl: url, // Meeting joining url
      },
      waitingScreen: {
        imageUrl: "<imageUrl || lottieUrl>",
        text: "Connecting to the meeting...",
      },
      //other params
        hls: {
            enabled: false,
            autoStart: false,
            theme: "DARK", // DARK | LIGHT | DEFAULT
            playerControlsVisible: false,
        },
        
        mode: "CONFERENCE", // VIEWER || CONFERENCE

      leftScreen: {
        // visible when redirect on leave not provieded
        actionButton: {
          // optional action button
          label: "Video SDK Live", // action button label
          href: "https://videosdk.live/", // action button href
        },
      },

      notificationSoundEnabled: true,

      debug: true, // pop up error during invalid config or netwrok error

      maxResolution: "hd", // "hd" or "sd"

    };

   //  await this.videoProcessor.start(stream, config);
    this.meeting = new VideoSDKMeeting();
    this.meeting.init(config);
  


    } catch (error) {
      console.error("Error initializing virtual background:", error);
      return null;
    }

  }  
  finalizarLlamada() {
    // this.meeting.close();

  }  

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/video-call/video-call.service.ts